import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";

toast.configure();
/**
 * @description function use for to get queue 
 * @param {*} params accepting object 
 */
export const getQueue = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/queue`, params, token, dispatch).then(
            (response) => {
                dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    dispatch({ type: 'LIST_QUEUE', data: response });
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const getDocumentsByQueueId = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/queue/documents`, params, token, dispatch).then(
            (response) => {
               
                dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    console.log('response',response)
                    dispatch({ type: 'LIST_DOCUMENT_IN_QUEUE', data: response });
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};



/**
 * @description function use for to archive queue 
 * @param {*} params accepting object 
 */
 export const archiveQueue = (params, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.delete(`${apiUrl}${PORT}/queue/${params.id}`, token, dispatch).then(
            (response) => {
                dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    dispatch({ type: 'LIST_QUEUE', data: response });
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};



/**
 * @description function use for to move document to cron job
 * @param {*} params accepting object 
 */
 export const moveToCronJob = (queueId, callback) => {

    console.log('queueId',queueId)
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/queue/moveToCronJob/${queueId}`,null, token, dispatch).then(
            (response) => {
                dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                   // dispatch({ type: 'LIST_QUEUE', data: response });
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};



/**
 * @description function use for to move sigle document to cron job
 * @param {*} params accepting object 
 */
 export const moveSingleDocumentToCronJob = (queueId,documentId, callback) => {

    console.log('documentId',documentId);
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/queue/moveDocumentToCronJob/${queueId}/${documentId}`,null, token, dispatch).then(
            (response) => {
                dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    console.log('response',response)
                    dispatch({ type: 'REMOVE_DOCUMENT', data: response });
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};

export const archiveQueueDocument = (queueId,documentId, callback) => {

    console.log('documentId',documentId);
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/queue/archiveQueueDocument/${queueId}/${documentId}`,null, token, dispatch).then(
            (response) => {
                dispatch({ type: "ISLOADING", data: false });
                if (response && !response.errors) {
                    console.log('response',response)
                    dispatch({ type: 'REMOVE_DOCUMENT', data: response.document });
                    callback && callback(response)
                } else if (response.code === 404) {
                    toast.error(response.message);
                    callback && callback(false)
                } else {
                    toast.error(response.errors.msg, toasterConfig);
                    callback && callback(false)
                }
            }
        );
    };
};





// export const deleteDraftFile = (params, callback) => {
//     return (dispatch, getState) => {
//       const {
//         user: { token },
//       } = getState();
//       ApiClient.delete(
//         `${apiUrl}${PORT}/documents/draft/${params.id}`,
//         token,
//         dispatch
//       ).then((response) => {
//         dispatch({ type: "ISLOADING", data: false });
//         if (response && !response.errors) {
//           callback(response);
//         } else if (response.code === 404) {
//           toast.warn(response.message);
//         } else {
//           toast.error(response.errors.msg, toasterConfig);
//         }
//       });
//     };
//   };






